import { Download } from "lucide-react";

// Renders one download button per available format (falls back to a single button)
export function DownloadButtons({ baseUrl, item, primaryTestId, compact = false }) {
  const formats = item.formats?.length ? item.formats : [null];
  const cls = compact
    ? "inline-flex items-center gap-1 text-sm text-[#0a192f] hover:text-[#d4af37] font-semibold"
    : "btn-gold inline-flex items-center gap-2";
  return (
    <div className={compact ? "flex flex-wrap gap-x-4 gap-y-1 mt-2" : "flex flex-wrap justify-center gap-2"} data-testid={`${primaryTestId}-group`}>
      {formats.map((f, i) => (
        <a
          key={f || "default"}
          data-testid={i === 0 ? primaryTestId : `${primaryTestId}-${f.replace(/\s+/g, "-").toLowerCase()}`}
          href={f ? `${baseUrl}&f=${encodeURIComponent(f)}` : baseUrl}
          className={cls}
        >
          <Download className={compact ? "w-3.5 h-3.5" : "w-4 h-4"} /> {f ? `${compact ? "" : "Download "}${f}` : `Download ${item.name}`}
        </a>
      ))}
    </div>
  );
}
